module.exports = __webpack_public_path__ + "assets/img/right.d135c71a.png";